<template>
  <div id="page-title" class="mb-5">
    <div class="bg-primary">
      <div class="container p-2 p-sm-5 text-center">
        <div class="p-5">
          <div
            class="text-white header-title mb-5"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            {{ title }}
          </div>
          <div class="text-light" data-aos="fade" data-aos-delay="500">
            {{ description }}
          </div>
        </div>
      </div>
    </div>

    <div class="page-title-border"></div>
  </div>
</template>

<script>
export default {
  props: ["title", "description"]
};
</script>

<style scoped>
.page-title-border {
  background-color: var(--primary);
  width: 100%;
  height: 50px;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
}
</style>
